import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { TableRow, TableCell } from '../ui/table';
import { Button } from '../ui/button';

const OrganisationsRow = ({ organisationDetails, industries, currencies }) => {
  return (
    <TableRow className='hover:bg-muted/50 text-base'>
      <TableCell className='font-medium text-left' id='organisation-name'>
        {organisationDetails.name}
      </TableCell>
      <TableCell>{_.find(industries, { id: organisationDetails?.industry })?.name}</TableCell>
      <TableCell>{_.find(currencies, { id: organisationDetails?.currency })?.symbol}</TableCell>
      <TableCell className='text-center'>
        <Button
          size='base'
          className='h-8 p-2 bg-secondary text-secondary-foreground hover:text-primary-foreground'
          id='Organisation-view-edit'
          asChild>
          <Link to={`/organisations/${organisationDetails.id}`}>View / Edit</Link>
        </Button>
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state) => {
  return {
    industries: state.organisation?.industries,
    currencies: state?.admin?.adminPortal?.currencies,
  };
};

export default connect(mapStateToProps, null)(OrganisationsRow);
